import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PublicSelectEnumComponent } from '@componentes/public-select/public-select-enum.component';
import {
	getLabelVariaveisEstacoes,
	ValuesVariaveis,
} from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/interfaces/estacao-monitorada';

@Component({
	selector: 'seira-public-select-variaveis-estacoes',
	templateUrl: './public-select.component.html',
	styleUrls: ['./public-select.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => PublicSelectVariavesEstacoesComponent),
		},
	],
})
export class PublicSelectVariavesEstacoesComponent extends PublicSelectEnumComponent {
	override label = 'Variável';
	override notFoundText = 'Nenhuma variável foi encontrada';
	override placeholder = 'Selecione a variável';

	constructor() {
		super(ValuesVariaveis, getLabelVariaveisEstacoes);
	}
}
